<ng-container>
  <div *ngIf="readonly">
    {{ getFormattedDataRangeStr() | replaceNullWith : '-' }}
  </div>

  <div [hidden]="readonly">
    <div class="date-range-container p-fluid">
      <div class="date-range-box">
        <sigv-date-picker
          #startCalendar
          [dateFormat]="dateFormat"
          [appendTo]="appendTo"
          [placeholder]="placeholder"
          [minDate]="minDate"
          [disabled]="disabled"
          [maxDate]="maxDate"
          [yearRange]="yearRange"
          [showTime]="showTime"
          [stepMinute]="stepMinute"
          [readonlyInput]="readonlyInput"
          [class.invalid]="showStartInvalid"
          [fieldName]="fieldName"
          (selected)="onStartCalendarSelect($event)"
          (inputed)="onStartCalendarInput($event)"
          (blured)="onStartCalendarBlur($event)"
          (focused)="onStartCalendarFocus($event)"
          (cleared)="onStartCalendarClear($event)"
        >
        </sigv-date-picker>
        <ng-container
          *ngIf="control?.errors?.['startRequired'] && isDateRangeRequired"
        >
          <small
            *ngIf="control?.errors?.['startRequired']||control?.errors?.['required']"
            class="p-error required"
            [translate]="validationMsgMap.startRequired"
            [translateParams]="translateParams"
          ></small
        ></ng-container>

        <ng-container
          *ngIf="control?.invalid && (control?.dirty || control?.touched)"
        >
          <small
            *ngIf="control?.errors?.['startInvalidDate']"
            class="p-error"
            [translate]="validationMsgMap.startInvalidDate"
            [translateParams]="translateParams"
          ></small>
          <small
            *ngIf="control?.errors?.['startDateGreaterThenSysdate']"
            class="p-error rangeInvalid"
            [translate]="validationMsgMap.startDateGreaterThenSysdate"
            [translateParams]="{range:control?.errors?.['startDateGreaterThenSysdate']?.range}"
          ></small>
          <ng-container *ngIf="startErrorMessageTemplate">
            <ng-container
              *ngTemplateOutlet="
                startErrorMessageTemplate;
                context: { $implicit: control }
              "
            ></ng-container>
          </ng-container>
        </ng-container>
      </div>
      <span class="date-range-sign">~</span>
      <div class="date-range-box">
        <sigv-date-picker
          #endCalendar
          [dateFormat]="dateFormat"
          [appendTo]="appendTo"
          [placeholder]="placeholder"
          [minDate]="minDate"
          [disabled]="disabled"
          [maxDate]="maxDate"
          [yearRange]="yearRange"
          [showTime]="showTime"
          [stepMinute]="stepMinute"
          [readonlyInput]="readonlyInput"
          [class.invalid]="showEndInvalid"
          [fieldName]="fieldName"
          (selected)="onEndCalendarSelect($event)"
          (inputed)="onEndCalendarInput($event)"
          (blured)="onEndCalendarBlur($event)"
          (focused)="onEndCalendarFocus($event)"
          (cleared)="onEndCalendarClear($event)"
        >
        </sigv-date-picker>
        <ng-container
          *ngIf="control?.errors?.['endRequired'] && isDateRangeRequired"
        >
          <small
            *ngIf="control?.errors?.['endRequired']||control?.errors?.['required']"
            class="p-error required"
            [translate]="validationMsgMap.endRequired"
            [translateParams]="translateParams"
          ></small
        ></ng-container>
        <ng-container
          *ngIf="control?.invalid && (control?.dirty || control?.touched)"
        >
          <small
            *ngIf="control?.errors?.['endInvalidDate']"
            class="p-error"
            [translate]="validationMsgMap.endInvalidDate"
            [translateParams]="translateParams"
          ></small>
          <small
            *ngIf="control?.errors?.['endDateGreaterThenSysdate']"
            class="p-error rangeInvalid"
            [translate]="validationMsgMap.endDateGreaterThenSysdate"
            [translateParams]="{range:control?.errors?.['endDateGreaterThenSysdate']?.range}"
          ></small>
          <ng-container *ngIf="endErrorMessageTemplate">
            <ng-container
              *ngTemplateOutlet="
                endErrorMessageTemplate;
                context: { $implicit: control }
              "
            ></ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <ng-container
      *ngIf="control?.invalid && (control?.dirty || control?.touched)"
    >
      <small
        *ngIf="control?.errors?.['rangeInvalid']"
        class="p-error rangeInvalid"
        [translate]="validationMsgMap.rangeInvalid"
        [translateParams]="translateParams"
      ></small>
      <small
        *ngIf="control?.errors?.['exceedMaxDateRange']"
        class="p-error rangeInvalid"
        [translate]="validationMsgMap.exceedMaxDateRange"
        [translateParams]="{range:control?.errors?.['exceedMaxDateRange']?.range}"
      ></small>
      <small
        *ngIf="control?.errors?.['dateGreaterThenSysdate']"
        class="p-error rangeInvalid"
        [translate]="validationMsgMap.dateGreaterThenSysdate"
        [translateParams]="{range:control?.errors?.['dateGreaterThenSysdate']?.range}"
      ></small>
      <small
        *ngIf="control?.errors?.['dateLessThenSysdate']"
        class="p-error rangeInvalid"
        [translate]="validationMsgMap.dateLessThenSysdate"
        [translateParams]="{range:control?.errors?.['dateLessThenSysdate']?.range}"
      ></small>
      <small
        *ngIf="control?.errors?.['dateRequired']"
        class="p-error rangeInvalid"
        [translate]="validationMsgMap.dateRequired"
        [translateParams]="{range:control?.errors?.['dateRequired']?.range}"
      ></small>
    </ng-container>
  </div>
</ng-container>
